<div class="reviewOverview">
    <span>{{ username }} hat <span class="review-org" (click)="openInNewTab(review.targetId)">{{ review.targetName
            }}</span> bewertet -
        {{ review.publishDate | humanReadableDate }}</span>
    <app-public-review [review]="review"></app-public-review>
</div>